import parseIso from 'date-fns/parseISO';
import addDays from 'date-fns/addDays';
import _isEmpty from 'lodash/isEmpty';
import _last from 'lodash/last';

export const SCHEDULE_TYPES = { recurring: 'recurring', oneTime: 'one-time' };

export const isRecurringSchedule = type => type === SCHEDULE_TYPES.recurring;

export const getNextSingleDayExceptionDate = formValues => {
  if (!formValues) return null;
  if (!_isEmpty(formValues.singleDayExceptions)) return addDays(parseIso(_last(formValues.singleDayExceptions)), 1);
  if (formValues.startDate) return parseIso(formValues.startDate);
  return null;
};
